import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    divider: {
        margin: theme.spacing(8, 0)
    },
    container: {
        marginBottom: theme.spacing(5),
        [theme.breakpoints.up('md')]: {
            marginBottom: theme.spacing(25)
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 4)
        }
    }
}));

export default useStyles;
